import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function AAD_mobile_view_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className='fs-6'>1. Introduction to Android Development</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to android, History of Android, Android version list, Android applications, Android vs IOS, OHA.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className='fs-6'>2. Environment & Setup</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Setup android studio, AVD, Debugging tools & emulator, Development of Ide, jdk, Structure & Components of android applications, Architecture of android & MVC, Importance of UI, Common components (Images, buttons, label, text fields, radio button, checkbox layout –horizontal & vertical, links WBI, calls, emails, messages, firebase & intro & services, Java requirement for app.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className='fs-6'>3. Hybrid Mobile Development</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Frameworks for HMD, Introduction to flutter, Introduction to Dart.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className='fs-6'>4. Dart</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Overview & intro, Functions & Types, String interpolation, Object oriented programming, Classes, instances, constructions & methods, OOP design flow, Loops & lists & variable 7 parameters, Reactive programming, Streams with controllers & transformers.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className='fs-6'>5. Flutter</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to flutter, Setup – android, iOS, pc, App overview, 4 step design process, Import statements & scaffold, Parameter clarification.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className='fs-6'>6. Flutter & Flutter apps</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Widgets (stateless vs stateful) Local import & refactoring stateless & stateful.
          <br></br>Triggering validation & retrieving form values, Code reuse with mixins & mixins validator implementation, Grid & horizontal list, Long list & alert & toast.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className='fs-6'>7. Forms using flutter</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Boilerplate app code, create login screen & STYLE CONTAINERS, Keyboard type customizing & labels & hint text, Handling password prints, Layout control, Form validation & widget & form state.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className='fs-6'>8. Understanding themes</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to UI & UX, Theme in flutter, data class-app brightness, over writing theme properties, Refactoring text theme & adding custom fonts, Applying font family to all text theme, Material. Oi overview, Color theme, typography & iconography.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel9bh-content"
          id="panel9bh-header"
        >
          <Typography className='fs-6'>9. Navigation</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Navigation to new routes, Navigation to named routes, Send data from one screen to another.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel10'} onChange={handleChange('panel10')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel10bh-content"
          id="panel10bh-header"
        >
          <Typography className='fs-6'>10. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major Project, Project overview.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
